import { C } from '../theme';
import { Icon, Mark } from '../icons';
import { Phone } from '../components/Phone';
import type { Me } from '../api';
import { useRoute } from '../useRoute';
import { TenantHome } from './TenantHome';
import { TenantStatement } from './TenantStatement';
import { TenantDocs } from './TenantDocs';
import { TenantRequests } from './TenantRequests';

const TABS = [
  ['home', 'home', 'Home'],
  ['statement', 'ledger', 'Statement'],
  ['docs', 'doc', 'Docs'],
  ['requests', 'wrench', 'Requests'],
] as const;

type Tab = (typeof TABS)[number][0];

const TAB_KEYS: Tab[] = ['home', 'statement', 'docs', 'requests'];

/** Tenant mobile app (fenced server-side to the caller's own tenancy). */
export function TenantApp({ onLogout }: { me: Me; onLogout: () => void }) {
  const { route, navigate } = useRoute();
  const tab: Tab = (TAB_KEYS as string[]).includes(route.section) ? (route.section as Tab) : 'home';

  const heading =
    tab === 'docs' ? 'Documents' : tab === 'requests' ? 'Requests' : tab === 'statement' ? 'Statement' : 'Home';

  return (
    <Phone>
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
        {/* top bar */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '6px 18px 12px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 9 }}>
            {tab === 'home' ? (
              <>
                <Mark size={26} />
                <span style={{ fontWeight: 600, color: C.ink, fontSize: 16 }}>Premise</span>
              </>
            ) : (
              <span style={{ fontWeight: 600, color: C.ink, fontSize: 16 }}>{heading}</span>
            )}
          </div>
          <button onClick={onLogout} aria-label="Log out" title="Log out" style={{ border: 0, background: 'transparent', color: C.ink2, cursor: 'pointer', display: 'flex', padding: 2 }}>
            <Icon n="logout" size={18} />
          </button>
        </div>

        {/* body */}
        <div className="premise-scroll" style={{ flex: 1, overflowY: 'auto', padding: '4px 16px 16px', display: 'flex', flexDirection: 'column', gap: 13 }}>
          {tab === 'home' && <TenantHome go={(t) => navigate(`#/${t}`)} />}
          {tab === 'statement' && <TenantStatement />}
          {tab === 'docs' && <TenantDocs />}
          {tab === 'requests' && <TenantRequests />}
        </div>

        {/* bottom tabs */}
        <div style={{ display: 'flex', borderTop: `1px solid ${C.line}`, background: C.card, paddingBottom: 'env(safe-area-inset-bottom)', flex: 'none' }}>
          {TABS.map(([key, icon, labelText]) => (
            <button
              key={key}
              onClick={() => navigate(`#/${key}`)}
              style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3, padding: '9px 0 11px', color: tab === key ? C.accent : C.muted, background: 'transparent', border: 0, fontSize: 10.4, fontWeight: 600, cursor: 'pointer' }}
            >
              <Icon n={icon} size={18} /> {labelText}
            </button>
          ))}
        </div>
      </div>
    </Phone>
  );
}
